import { render, staticRenderFns } from "./PrecintoRangos.vue?vue&type=template&id=68e586d3"
import script from "./PrecintoRangos.vue?vue&type=script&lang=js"
export * from "./PrecintoRangos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports